import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Plus } from "@phosphor-icons/react";
import { QuickBookingForm } from "@/pages/Bookings";

/**
 * Auffälliger MSB-grüner Schnellzugriff-Button auf dem Dashboard.
 * Öffnet direkt die vollständige "Neue Buchung"-Blitz-Eingabe (Gast + Zeitraum + Zimmer + Extras).
 * Nur für Admins sichtbar (Mitarbeiter erstellen keine Buchungen).
 */
export default function NewBookingButton({ guest = null, label = "Neue Buchung", testId = "dash-btn-new-booking", className = "rounded-xl bg-primary hover:bg-primary/90 text-white h-12 px-5 shadow-sm font-semibold" }) {
  const { user } = useAuth();
  const [open, setOpen]   = useState(false);
  const [rooms, setRooms] = useState([]);
  const prefill = useMemo(() => (guest && open ? { guest } : null), [guest, open]);

  useEffect(() => {
    if (user?.role !== "admin") return;
    api.get("/rooms").then(r => setRooms(r.data || [])).catch(() => {});
  }, [user]);

  if (user?.role !== "admin") return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          data-testid={testId}
          className={className}>
          <Plus size={18} weight="bold"/>
          <span className="ml-2">{label}</span>
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid={`${testId}-dialog`}>
        <DialogHeader>
          <DialogTitle>Neue Buchung · Blitz-Eingabe</DialogTitle>
        </DialogHeader>
        <QuickBookingForm
          rooms={rooms}
          prefill={prefill}
          onSaved={() => setOpen(false)}
          onCancel={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
